import {BaseClient} from '../utils/base-client';

interface OnDemandAnalysisRequest {
  projectId: number;
  taskId: string;
  fromDate: string;
  toDate: string;
  bookmark: string;
  bookmarkType: string;
  bookmarkId: number;
  bookmarkUrl: string;
  reportDirty: boolean;
  workspaceId: number;
}

export type ODAErrorResponse = {
  status: `error`;
  error: string;
};

export type ODASuccessResponse = {
  status: `ok`;
  results: {
    messageIds: string[];
  };
};

class OnDemandAnalysisClient extends BaseClient {
  public buildEndpoint({projectId, workspaceId}) {
    const workspaceOrProject = workspaceId ? `workspaces/${workspaceId}` : `projects/${projectId}`;
    return `api/app/${workspaceOrProject}/analysis/`;
  }

  public buildRequestBody({
    fromDate,
    toDate,
    bookmarkId,
    bookmarkType,
    bookmark,
    bookmarkUrl,
    reportDirty,
    taskId,
  }: {
    fromDate: string;
    toDate: string;
    bookmarkId: string;
    bookmarkType: string;
    bookmark: string;
    bookmarkUrl: string;
    reportDirty: boolean;
    taskId: string;
  }) {
    return JSON.stringify({
      from: `${fromDate}`,
      to: `${toDate}`,
      bookmark_id: parseInt(bookmarkId, 10),
      bookmark_type: bookmarkType,
      bookmark,
      bookmark_url: bookmarkUrl,
      report_dirty: reportDirty,
      task_id: taskId || `${bookmarkType}-${bookmarkId}-${new Date().toISOString()}`,
    });
  }

  public query(params: OnDemandAnalysisRequest): Promise<ODASuccessResponse | ODAErrorResponse> {
    return super.query(params, {clearCache: true});
  }
}

export const onDemandAnalysisClient = new OnDemandAnalysisClient();
